import { Link } from 'react-router-dom';
import { dayName, formatDayPhrase } from '@bookingdei/i18n/format-date';
import { localiseDigits } from '@bookingdei/i18n/format-number';
import { statusLabelKeyOrNull } from '@bookingdei/i18n/status-label';
import { statusColours } from '../../theme/tokens';
import { useLanguage } from '../../shell/language-context';
import { displayStatus } from '../bookings/booking-tabs';
import { HomeIcon } from './home-icons';
import type { Booking } from '../../mock/seeds/schema-types';

// "Next up" (customer gap §A.3 H5; Home.dc.html L132-157): the two live bookings after
// the hero — a two-line date tile (day over weekday, so every row aligns), service,
// "when · place", the status chip — each opening its booking sheet.
export function HomeNextUp({ bookings, now }: { bookings: Booking[]; now: Date }) {
  const { t, lang } = useLanguage();
  return (
    <section className="hm-card hm-next" data-motion="">
      <div className="hm-sec-head">
        <span className="hm-sec-head__title">{t('user.home.next_up')}</span>
        <Link className="hm-sec-head__link" to="/bookings">
          {t('user.home.all_bookings')}
        </Link>
      </div>
      <div className="hm-next__rows">
        {bookings.map((b) => {
          const d = b.starts_at ? new Date(b.starts_at) : null;
          const shown = displayStatus(b, now);
          const c = statusColours('booking_status', shown);
          const key = statusLabelKeyOrNull('booking_status', shown);
          const bizName =
            (lang === 'bn' ? b.business?.name_bn : undefined) ?? b.business?.name ?? '';
          const place = [bizName, b.business?.area_name].filter(Boolean).join(' — ');
          return (
            <Link
              key={b.id}
              className="hm-next__row"
              to={`/bookings?b=${encodeURIComponent(b.code)}`}
            >
              <span className="hm-next__date">
                <span className="hm-next__day">{d ? localiseDigits(lang, d.getDate()) : '—'}</span>
                <span className="hm-next__dow">{d ? dayName(lang, d.getDay()) : ''}</span>
              </span>
              <span className="hm-next__text">
                <span className="hm-next__service">{b.items?.[0]?.name_snapshot ?? b.code}</span>
                <span className="hm-next__meta">
                  {[d ? formatDayPhrase(lang, d, now) : '', place].filter(Boolean).join(' · ')}
                </span>
              </span>
              <span className="hm-next__chip" style={{ background: c.bg, color: c.fg }}>
                <span
                  className="hm-next__chip-dot"
                  style={{ background: c.dot }}
                  aria-hidden="true"
                />
                {key ? t(key) : shown}
              </span>
              <HomeIcon name="chevron" className="hm-next__chev" />
            </Link>
          );
        })}
      </div>
    </section>
  );
}
